import { PayloadAction, createAction } from '@reduxjs/toolkit';
import { RootState } from './RootState';

export const hydrateType = '___HYDRATE___';
export const hydrate = createAction<Partial<RootState>>(hydrateType);
export type HydrateAction = PayloadAction<Partial<RootState>, typeof hydrateType>;
